import React, { ReactNode } from "react";
import styles from "./styles.module.scss";

export interface ModalBodyProps {
  className?: string;
  children?: ReactNode;
}

const ModalBody: React.FC<ModalBodyProps> = ({ children, className = "" }) => {
  const classNames = ["modal-body", styles.body, className]
    .filter(Boolean)
    .join(" ");

  return <div className={classNames}>{children}</div>;
};

export default ModalBody;
